import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core'

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms'

export const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ButtonGroupComponent),
  multi: true,
}

@Component({
  selector: 'button-group',
  styleUrls: ['button-group.component.less'],
  templateUrl: 'button-group.component.html',
  providers: [
    VALUE_ACCESSOR
  ],
  host: {
    class: 'ui buttons'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonGroupComponent implements ControlValueAccessor {
  @Input() disabled = false
  @Input() options: any[]
  @Input() unselectable: boolean = true
  @Input() multiple: boolean
  @Output() modelChange = new EventEmitter<any>()

  modelValue = []

  onChange: Function | null
  onTouched: Function | null

  constructor(private changeRef: ChangeDetectorRef) {}

  setValue(newValue) {
    if (this.modelValue && this.modelValue.includes(newValue)) {
      if (this.unselectable || this.modelValue.length > 1) {
        this.modelValue.remove(newValue)
      }
    } else if (this.modelValue && this.multiple) {
      this.modelValue.append(newValue)
    } else {
      this.modelValue = [newValue]
    }
    this.changeRef.markForCheck()
    if (this.onChange) {
      if (this.multiple) {
        this.onChange(this.modelValue)
      } else {
        this.onChange(this.modelValue && this.modelValue.first())
      }
    }
    this.onTouched()
  }

  writeValue(modelValue) {
    this.modelValue = [modelValue].flatten().compact()
    this.changeRef.markForCheck()
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled
    this.changeRef.markForCheck()
  }

  registerOnChange(fn: any) {
    this.onChange = fn
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn
  }

  isActive(option) {
    return this.modelValue && this.modelValue.includes(option)
  }
}
